import React from 'react';
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, Divider, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NProgress from '../../utils/nprogress';
import { motion } from 'framer-motion';

// آیکون‌ها
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';

const drawerWidth = 240; // عرض منو بدون تغییر

const DashboardMenu = ({ activeItem, onItemClick }) => {
  const navigate = useNavigate();

  const menuItems = [
    { text: 'آمار کلی', icon: <SpaceDashboardOutlinedIcon />, route: 'overview' },
    { text: 'محصولات', icon: <Inventory2OutlinedIcon />, route: 'products' },
    { text: 'سفارشات', icon: <ReceiptLongOutlinedIcon />, route: 'orders' },
    { text: 'مشتریان', icon: <PeopleAltOutlinedIcon />, route: 'customers' },
    { text: 'تنظیمات', icon: <SettingsOutlinedIcon />, route: 'settings' }
  ];

  // منطق کلیک بدون تغییر باقی می‌ماند
  const handleItemClick = (menuItemText, route) => {
    NProgress.start();
    setTimeout(() => {
      onItemClick(menuItemText);
      navigate(`/project/37/dashboard/${route}`);
      NProgress.done();
    }, 300);
  };

  const listVariants = {
    visible: { transition: { staggerChildren: 0.07 } }
  };

  const itemVariants = {
    hidden: { y: 15, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.3 } }
  };

  return (
    <Drawer
      variant="permanent"
      anchor="right"
      open
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: 'border-box',
          // استایل شیشه‌ای هماهنگ با داشبورد
          background: 'rgba(12, 19, 29, 0.7)',
          backdropFilter: 'blur(16px)',
          borderLeft: '1px solid rgba(255, 255, 255, 0.1)',
          color: 'white',
        },
      }}
    >
      <Box sx={{ overflow: 'auto', p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', pb: 1 , gap: 1 , justifyContent: 'center'}}>
          <WysiwygIcon sx={{ color: '#61dafb', fontSize: '2rem' }} />
          <Typography variant="h5" noWrap sx={{ fontWeight: 'bold' }}>
            داشبورد
          </Typography>
        </Box>
        <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)', my: 1 }} />
        <List component={motion.div} variants={listVariants} initial="hidden" animate="visible">
          {menuItems.map((item) => (
            <ListItem component={motion.div} variants={itemVariants} key={item.text} disablePadding sx={{ my: 1 }}>
              <ListItemButton
                selected={activeItem === item.text}
                onClick={() => handleItemClick(item.text, item.route)}
                sx={{
                  textAlign: 'right',
                  borderRadius: '8px',
                  py: 1.5,
                  color: 'rgba(255, 255, 255, 0.7)',
                  transition: 'background-color 0.3s, color 0.3s, transform 0.2s',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    color: '#fff',
                    transform: 'translateX(-5px)'
                  },
                  '&.Mui-selected': {
                    backgroundColor: '#fff',
                    color: '#16222a',
                    fontWeight: 'bold',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.25)',
                    '&:hover': {
                        backgroundColor: '#fff',
                    },
                    '.MuiListItemIcon-root': {
                        color: '#000',
                    }
                  }
                }}
              >
                <ListItemIcon sx={{ color: 'inherit', minWidth: '45px' }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default DashboardMenu;